module.exports = __webpack_public_path__ + "2bc74f29cac1fafdaa979e2169ef3c7e.png";